// eslint-disable-next-line no-restricted-imports
import { useSelector } from "react-redux";

import { type DeprecatedReduxState } from "./types";

export function useIsAdmin() {
  return useSelector((state: DeprecatedReduxState) => state.session.admin);
}
